module.exports = __webpack_public_path__ + "static/media/TUNE_4336.d8368c84.jpg";